import { Box, Badge, Grid, ActionIcon } from '@mantine/core';

function GameHeader({ gameName, roomCode, onReconnect, onQuit, timerSeconds }) {
  const timerBadge = timerSeconds > 0 ? (
    <Badge size="lg" color={timerSeconds <= 10 ? 'red' : 'orange'} variant="filled">
      {timerSeconds}s
    </Badge>
  ) : null;

  return (
    <Box
      style={{
        flexShrink: 0,
        padding: '0.5rem 0.75rem',
        backgroundColor: '#fff',
        borderBottom: '1px solid #e9ecef',
      }}
    >
      <Grid align="center">
        <Grid.Col span={4}>
          <Box
            style={{
              fontWeight: 700,
              fontSize: '1.1rem',
              fontFamily: '"Pangolin", "Fredericka the Great", "Rock Salt", cursive',
              color: '#228be6',
            }}
          >
            {gameName}
          </Box>
        </Grid.Col>
        <Grid.Col span={4} style={{ textAlign: 'center' }}>
          {roomCode && (
            <Badge
              size="md"
              variant="filled"
              color="blue"
              style={onReconnect ? { cursor: 'pointer' } : undefined}
              onClick={onReconnect}
            >
              {roomCode}{onReconnect ? ' ↻' : ''}
            </Badge>
          )}
        </Grid.Col>
        <Grid.Col span={4} style={{ textAlign: 'right', display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 8 }}>
          {timerBadge}
          {onQuit && (
            <ActionIcon
              variant="light"
              color="red"
              size="md"
              onClick={onQuit}
              title="Quit game"
            >
              ✕
            </ActionIcon>
          )}
        </Grid.Col>
      </Grid>
    </Box>
  );
}

export default GameHeader;
